export default {

    props: {
        validateGeneration: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            hasGenerationValidationError: false,
        }
    },

    methods: {
        validateAssessmentReportGeneration() {

            if(!this.validateGeneration) {
                return new Promise( resolve => { resolve(true)});
            }

            return new Promise((resolve, reject) => {

                axios.get('/api/projects/' + this.project.id + '/validateAssessmentReportGeneration', {
                    params: {
                        phase: this.phase.id,
                        scenario: this.currentScenario.id
                    }
                }).then(response => {
                    if(response.data.is_valid) {
                        resolve(true);
                    }else {
                        reject('invalid');
                    }

                }).catch(error => {
                    window.notify.apiError(error);
                    reject('apiError');
                })

            })
        }
    }
}
